import { Box, Skeleton, Stack, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { useEntitlementKey } from "hooks";
import React from "react";

export const DealSkeletonTile: React.FC = () => {
  const borderColor = useColorModeValue("gray.300", "gray.600");
  const bgColor = useColorModeValue("white", "gray.700");
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  const startColor = useColorModeValue("gray.200", "gray.900");
  const endColor = useColorModeValue("gray.50", "gray.800");
  const hasDealFinderPurchase = useEntitlementKey("ui_enable_dealfinder_purchase");

  const skeletonStyle = {
    startColor: startColor,
    endColor: endColor,
  };

  return (
    <Box
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="xl"
      overflow="hidden"
      bg={bgColor}
      height="100%"
      display="flex"
      flexDirection="column">
      <Stack spacing={0} flex={1}>
        <Box height="62px" display="flex" alignItems="center">
          <Skeleton {...skeletonStyle} ml="1rem" height="28px" width="50%" />
        </Box>
        <Skeleton {...skeletonStyle} height="128px" width="100%" />
        <Stack spacing={2} flex={1} alignItems="flex-start" height={"100%"} justifyContent={"space-between"}>
          <Stack spacing="1rem" p="1rem" alignContent={"top"} height={hasDealFinderPurchase ? "154px" : "50px"} width="100%">
            <Stack direction="row" width="100%" justify="space-between">
              <Skeleton {...skeletonStyle} height="1.3rem" width="30%" />
              <Skeleton {...skeletonStyle} height="1.3rem" width="30%" />
            </Stack>
            {hasDealFinderPurchase && <Skeleton {...skeletonStyle} height="3rem" width="100%" />}
          </Stack>
          <Stack
            direction="row"
            width="100%"
            justify="space-between"
            px={isMobile ? ".5rem" : "1rem"}
            py={isMobile ? ".2rem" : ".5rem"}
            borderTop="1px solid"
            borderColor={borderColor}>
            <Skeleton {...skeletonStyle} borderRadius={"lg"} height="1rem" width="1rem" />
            <Skeleton {...skeletonStyle} borderRadius={"lg"} height="1rem" width="1rem" />
            <Skeleton {...skeletonStyle} borderRadius={"lg"} height="1rem" width="1rem" />
            <Skeleton {...skeletonStyle} borderRadius={"lg"} height="1rem" width="1rem" />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
